module.exports = __webpack_public_path__ + "fonts/Montserrat-Regular.b8801d7d.WOFF";